/* HEALR — lazy-play for below-fold autoplay videos.
   Wrappers marked [data-lazy-video] contain a muted looping <video> rendered
   WITHOUT the autoplay attribute and with preload="none", so nothing downloads
   at page load. We start playback just before the wrapper scrolls into view
   (200px lookahead) and pause it when it leaves — visually identical to
   autoplay, minus ~30MB of upfront video download.

   Marquee galleries (social-gallery ticker) are handled as a GROUP: the
   ticker JS clones the card strip ~11x to build its infinite loop, and
   per-card observation of elements moved by a compositor CSS animation is
   unreliable — clones never fired, never got data, and the theme's CSS keeps
   videos at opacity:0 until loadeddata marks the wrapper --ready (the "gray
   cards" bug). One observer on the static [data-ticker-frame] drives them.

   WITHIN a visible marquee we play only the videos near the viewport, on a
   light 400ms timer (the strip moves via CSS animation, so a one-time check
   would go stale). Playing all ~48 at once worked on desktop but exceeded
   iOS's simultaneous-video-decoder cap, so iPhones paused everything and
   showed stills. The hidden .ticker__comparator strip is skipped. */
(function () {
  var EDGE = 300; // px lookahead around the viewport

  function playVideo(v) {
    v.muted = true; // belt-and-braces: programmatic play() is only allowed when muted
    if (v.preload === 'none') v.preload = 'auto';
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function groupVideos(frame) {
    var out = [];
    var vids = frame.querySelectorAll('[data-lazy-video] video');
    for (var i = 0; i < vids.length; i++) {
      if (!vids[i].closest('.ticker__comparator')) out.push(vids[i]); // comparator is invisible measuring markup
    }
    return out;
  }

  function nearViewport(el) {
    var r = el.getBoundingClientRect();
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.right > -EDGE && r.left < vw + EDGE && r.bottom > -EDGE && r.top < vh + EDGE;
  }

  function updateGroup(frame) {
    var vids = groupVideos(frame); // re-query: includes any clones made after init
    for (var i = 0; i < vids.length; i++) {
      if (nearViewport(vids[i])) {
        if (vids[i].paused) playVideo(vids[i]);
      } else if (!vids[i].paused) {
        vids[i].pause();
      }
    }
  }

  function startGroup(frame) {
    if (frame.__hlvTimer) return;
    updateGroup(frame);
    frame.__hlvTimer = setInterval(function () { updateGroup(frame); }, 400);
  }

  function stopGroup(frame) {
    if (frame.__hlvTimer) {
      clearInterval(frame.__hlvTimer);
      frame.__hlvTimer = null;
    }
    var vids = groupVideos(frame);
    for (var i = 0; i < vids.length; i++) {
      if (!vids[i].paused) vids[i].pause();
    }
  }

  function init() {
    var wraps = document.querySelectorAll('[data-lazy-video]');
    if (!wraps.length) return;

    var singles = [];
    var frames = [];
    for (var i = 0; i < wraps.length; i++) {
      var frame = wraps[i].closest('[data-ticker-frame]');
      if (frame) {
        if (frames.indexOf(frame) === -1) frames.push(frame);
      } else {
        singles.push(wraps[i]);
      }
    }

    if (!('IntersectionObserver' in window)) {
      // Ancient browser: behave exactly like the old autoplay markup
      for (var a = 0; a < singles.length; a++) {
        var sv = singles[a].querySelector('video');
        if (sv) playVideo(sv);
      }
      for (var b = 0; b < frames.length; b++) {
        groupVideos(frames[b]).forEach(playVideo);
      }
      return;
    }

    if (singles.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target.querySelector('video');
          if (!v) return;
          if (entry.isIntersecting) {
            playVideo(v);
          } else if (!v.paused) {
            v.pause(); // also saves battery/CPU while offscreen
          }
        });
      }, { rootMargin: '200px 0px 200px 0px' });
      for (var j = 0; j < singles.length; j++) io.observe(singles[j]);
    }

    if (frames.length) {
      // Group observer: the frame is static in the page (only its inner strip
      // animates), so viewport intersection on it is reliable. While visible,
      // the per-frame timer decides which of its videos actually play.
      var gio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startGroup(entry.target);
          } else {
            stopGroup(entry.target);
          }
        });
      }, { rootMargin: '200px 0px 200px 0px' });
      for (var f = 0; f < frames.length; f++) gio.observe(frames[f]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
